<!--
Just the "selector" part of a select element. Stylized to our app design.
-->
<template>
	<div>
		<div v-if="props.label" class="pb-1 pl-1 text-sm">
			{{ props.label }}
		</div>
		<div
			class="flex min-h-[2.6rem] items-center justify-between rounded-md bg-[#edeef0] px-2"
		>
			<div>
				<slot>
					{{ value ?? placeholder }}
				</slot>
			</div>
			<ion-icon :icon="caretDownOutline" />
		</div>
		<div v-if="props.error" class="pl-1 pt-0.5 text-xs text-red-600">
			{{ props.error }}
		</div>
	</div>
</template>

<script setup lang="ts">
	import { IonIcon } from "@ionic/vue";
	import { caretDownOutline } from "ionicons/icons";

	interface SgSelectElementProps {
		label?: string;
		value?: string;
		placeholder?: string;
		error?: string;
	}

	const props = defineProps<SgSelectElementProps>();
</script>
